import React from 'react';

import '../icon-component.scss';

const UploadComponent = () => (
  <svg width="15px" height="16px" className="icon-component" viewBox="0 0 15 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
      <g transform="translate(1.000000, 0.000000)">
        <path d="M0,19.5 L12.675,19.5" strokeLinejoin="round" />
        <path d="M6.5,16.115125 L6.5,1.3" />
        <polyline points="12.025 5.3625 6.6625 0 1.3 5.3625" />
      </g>
    </g>
  </svg>
);

UploadComponent.displayName = 'UploadIcon';

export default UploadComponent;
